import {createContext, useContext} from 'react';

interface TourContextValue {
    setTourHandler: (handler: (() => void) | null) => void;
}

export const TourContext = createContext<TourContextValue>({
    setTourHandler: () => {},
});

export function useTourContext() {
    return useContext(TourContext);
}
